/**
 * @flow
 * @relayHash 89d0aa94d7ec3e0cd3bf61fc19c0bcea
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Suggest_suggestSearch$ref = any;
export type SuggestLoaderQueryVariables = {||};
export type SuggestLoaderQueryResponse = {|
  +suggestSearch: ?{|
    +$fragmentRefs: Suggest_suggestSearch$ref
  |}
|};
export type SuggestLoaderQuery = {|
  variables: SuggestLoaderQueryVariables,
  response: SuggestLoaderQueryResponse,
|};
*/


/*
query SuggestLoaderQuery {
  suggestSearch {
    ...Suggest_suggestSearch
  }
}

fragment Suggest_suggestSearch on SuggestSearch {
  search(keyword: "") {
    productKeyword
    productType
  }
}
*/

const node/*: ConcreteRequest*/ = {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SuggestLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "suggestSearch",
        "storageKey": null,
        "args": null,
        "concreteType": "SuggestSearch",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Suggest_suggestSearch",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SuggestLoaderQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "suggestSearch",
        "storageKey": null,
        "args": null,
        "concreteType": "SuggestSearch",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "search",
            "storageKey": "search(keyword:\"\")",
            "args": [
              {
                "kind": "Literal",
                "name": "keyword",
                "value": ""
              }
            ],
            "concreteType": "SuggestProduct",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "productKeyword",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "productType",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SuggestLoaderQuery",
    "id": null,
    "text": "query SuggestLoaderQuery {\n  suggestSearch {\n    ...Suggest_suggestSearch\n  }\n}\n\nfragment Suggest_suggestSearch on SuggestSearch {\n  search(keyword: \"\") {\n    productKeyword\n    productType\n  }\n}\n",
    "metadata": {}
  }
};
// prettier-ignore
(node/*: any*/).hash = 'ac90de75ce7cc9165dff3e47f85e5bf9';
module.exports = node;
